import Return_arrow from "../assets/images/svg/return_arrow.svg";

export const IconReturn = () =>{
    return(
        <>
            <a href="javascript: history.go(-1)">
                <img className="btn_return" src={Return_arrow} height="25px" alt="Regresar" />
            </a>
        </>
    )
}